<template>
  <v-container fluid class="tp-page">
    <!-- Cabeçalho -->
    <div class="tp-page-head">
      <div>
        <h1 class="tp-page-title">Indicações</h1>
        <p class="tp-page-sub">{{ tabela.conteudo.length }} {{ tabela.conteudo.length === 1 ? 'indicação' : 'indicações' }} no total</p>
      </div>
      <div class="tp-head-actions">
        <v-select outlined dense hide-details v-model="eventoId" :items="eventos" item-text="nome" item-value="id" label="Selecione o Evento" @input="carregaDados()" color="#00695C"></v-select>
        <v-text-field v-model="tabela.busca" prepend-inner-icon="mdi-magnify" placeholder="Buscar…" hide-details dense outlined color="#00695C" class="tp-search"></v-text-field>
      </div>
    </div>

    <!-- Tabela -->
    <v-card class="tp-card" elevation="0">
      <v-data-table :search="tabela.busca" :headers="tabela.cabecalho" :items="tabela.conteudo" sort-desc>
        <template v-slot:no-data>
          <v-alert dense text outlined :value="true" color="warning" icon="info" class="ma-3">Nenhuma indicação realizada</v-alert>
        </template>
        <template slot="no-results">
          <v-alert dense text outlined :value="true" color="warning" icon="info" class="ma-3">Sua pesquisa por "{{tabela.busca}}" não trouxe resultados</v-alert>
        </template>
      </v-data-table>
    </v-card>
    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import moment from 'moment'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    components: { Snackbar, Loading },
    data: () => ({
      fullPage: true,
      isLoading: false,
      addUser: false,
      temInscritos: false,
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Nome', align: 'start', value: 'nome', },
          { text: 'Total Indicações', align: 'center', value: 'totalInscricoes' },
          { text: 'Indicações Pendentes', align: 'center', value: 'pendentes' },
          { text: 'Indicações Pagas', align: 'center', value: 'pagas' },
        ],
        conteudo: []
      },
      eventos: [],
      eventoId: '',
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
    }),

    mounted() {
      this.carregaDados()
    },

    watch: {
      
    },

    methods: {
      async carregaDados() {
        this.isLoading = true
        await axios.get(baseApiUrl + 'Eventos?filter={"where":{"and":[{"empresaId":"'+this.companyobj.id+'"}]}}&access_token=' + sessionStorage.getItem('accToken')).then(response => {
          if (response.data) {
            for (var key in response.data) {
              if (response.data.hasOwnProperty(key)) {
                this.eventos.push(response.data[key])
              }
            }
            this.eventos = this.eventos.sort(this.compare)
            this.eventoId = this.eventos[0].id
          } else {
            this.isLoading = false
          }
        })
        await this.carregaIndicacoes()
      },

      async carregaIndicacoes() {
        this.isLoading = true
        await axios.post(baseApiUrl + 'Divulgadores/qtdInscricoes?access_token=' + sessionStorage.getItem('accToken'), {"eventoId": this.eventoId}).then(response => {
          if (response.data) {
            this.tabela.conteudo = response.data
            this.isLoading = false
          } else {
            this.isLoading = false
          }
        })
      },

      compare(a) {
        // Use toUpperCase() to ignore character casing
        const dataA = moment(this.formatDateHora(a.fim), 'DD/MM/YYYY HH:mm:ss', true).format()
        //const dataB = new Date(moment(this.formatDatePadrao(b.fim)).format('YYYY-MM-DDTHH:mm:ss.000Z').replace('-03:00', 'Z'))
        const dataC = moment().format()
        let comparison = 0;
        if (dataC >= dataA) {
          comparison = 1;
        } else if (dataC < dataA) {
          comparison = -1;
        }
        return comparison;
      },

      formatDate(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDateBrz(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePadrao(date) {
        if (!date) return null

        const [day, month, year] = date.substr(0, 10).split('/')
        return `${year}-${month}-${day}` + " " + date.substr(11, 6)
      },

      formatDateHora(date) {
        if (!date) return null

        const [year, month, day] = date.substr(0, 10).split('-')
        return `${day}/${month}/${year}` + " " + date.substr(11, 8)
      },

      close() {
        this.addUser = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px;
    width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }
</style>